import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pool/createNewPool`, method: 'POST', body: values, token: token})
}
